module.exports = __webpack_public_path__ + "static/media/Salary55k.3f91fb8e.png";